<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      PSI Map
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<ion-content>
  <!--Map-->
  <div id="map" class="map"></div>
  
  <a class="osm-tag" href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer" >© OpenStreetMap Contributors</a>

  <!--Location Button-->
  <ion-button class="button-loc" size="small" color="light" mode="md" expand="block" (click)="findUserlocation()">
    <ion-icon slot="icon-only" name="locate"></ion-icon>
  </ion-button>

  <!--PSI Button-->
  <ion-button class="button-psi" size="small" color="light" mode="md" expand="block" (click)="goBackToPsi()">
    PSI
  </ion-button>
</ion-content>

  
